import React, { useRef, useState, useEffect } from 'react'
import { AiFillEdit } from 'react-icons/ai'
import { developtap } from '../../service/tabarray'
import Project_estimate from './Project_estimate'
import Project_contract from './Project_contract'
import Project_file from './Project_file'
import { STEP } from '../Project/projectStepManager'
import ProjectHeader from './projectViews/ProjectHeader'

function Projectdevelop({
    my,
    contract,
    project,
    offer,
    handleChanges,
    offerlist,
    onClick,
    onClickss,
    userId,
    setDedit,
}) {
    const estimateImgRef = useRef()
    const specificationImgRef = useRef()
    const develop1Ref = useRef()
    const develop2Ref = useRef()
    const develop3Ref = useRef()
    const [inputImage, setInputImage] = useState(null)
    const [num, setNum] = useState(1)

    useEffect(
        function () {
            if (project && project.adminstatus === STEP.ESTIMATE_WRITE) {
                setNum(1)
            } else if (project && project.adminstatus === STEP.CONTRACT_WRITE) {
                setNum(2)
            } else if (project && project.adminstatus === STEP.DEV1) {
                setNum(3)
            } else if (project && project.adminstatus === STEP.DEV2) {
                setNum(3)
            } else if (project && project.adminstatus === STEP.FINAL_REPORT) {
                setNum(3)
            }
        },
        [project],
    )
    const savePdfFile = (imgRef) => {
        const file = imgRef.files[0]
        const reader = new FileReader()
        reader.readAsDataURL(file)
        reader.onloadend = () => {
            setInputImage(reader.result)
        }
    }

    var writeTitleMap = {}
    writeTitleMap[STEP.ESTIMATE_WRITE] = '견적서 작성'
    writeTitleMap[STEP.CONTRACT_WRITE] = '계약서 작성'
    writeTitleMap[STEP.DEV1] = '1단계 개발'
    writeTitleMap[STEP.DEV2] = '2단계 개발'
    writeTitleMap[STEP.FINAL_REPORT] = '3단계 개발'

    return (
        <>
            {project ? (
                <>
                    <div className={!my ? 'add_right_wrap wide pgdetail' : 'wide'}>
                        <div className="ModalMypageInfo develop">
                            <ProjectHeader pg={project} viewTitle={writeTitleMap[project && project.adminstatus]} />

                            <nav>
                                <ul className="w100 flex">
                                    {developtap.map((item) => (
                                        <li
                                            key={item.value}
                                            className={item.value === num ? 'selected p10' : 'p10'}
                                            onClick={() => setNum(item.value)}
                                        >
                                            {`${item.label}`}
                                        </li>
                                    ))}
                                </ul>
                            </nav>
                            {num === 1 ? (
                                <Project_estimate
                                    userId={userId}
                                    savePdfFile={savePdfFile}
                                    estimateImgRef={estimateImgRef}
                                    handleChanges={handleChanges}
                                    offerlist={offerlist}
                                    project={project}
                                    offer={offer}
                                    contract={contract}
                                    onClickss={onClickss}
                                    setDedit={setDedit}
                                />
                            ) : num === 2 ? (
                                <Project_contract
                                    userId={userId}
                                    savePdfFile={savePdfFile}
                                    handleChanges={handleChanges}
                                    contract={contract}
                                    project={project}
                                    onClick={onClick}
                                    onClickss={onClickss}
                                    specificationImgRef={specificationImgRef}
                                    offerlist={offerlist}
                                />
                            ) : num === 3 ? (
                                <Project_file
                                    userId={userId}
                                    savePdfFile={savePdfFile}
                                    handleChanges={handleChanges}
                                    contract={contract}
                                    project={project}
                                    onClick={onClick}
                                    onClickss={onClickss}
                                    develop1Ref={develop1Ref}
                                    develop2Ref={develop2Ref}
                                    develop3Ref={develop3Ref}
                                />
                            ) : null}
                        </div>
                    </div>
                </>
            ) : null}
        </>
    )
}

export default Projectdevelop
